import { Modal, Box } from "@mui/material";

const ModalWrapper = ({ open, onClose, children, className = "" }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box className={`flex items-center justify-center backdrop-blur-sm ${className}`}>
        {children}
      </Box>
    </Modal>
  );
};

export default ModalWrapper;
